import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  templateId?: string;
  enabled?: boolean;
}

const useGetHtmlPreviewQuery = ({ templateId, enabled }: Props) => {
  const { data, isLoading, isError, refetch } = useQuery(
    [API_URL.EXTERNAL_TEMPLATES_HTML_PREVIEW_BY_ID(templateId as string)],
    () => api.get(API_URL.EXTERNAL_TEMPLATES_HTML_PREVIEW_BY_ID(templateId as string)),
    { enabled: Boolean(enabled && templateId) }
  );

  return {
    htmlContent: data?.data,
    isHTMLContentLoading: isLoading,
    isHTMLContentError: isError,
    onRefetchHTMLContent: refetch,
  };
};

export default useGetHtmlPreviewQuery;
